import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const CreateUserDonationDetails = createAsyncThunk(
  "/website/user-donation-details",
  async (data, { rejectWithValue }) => {
    try {
      console.log("data", data)
      const res = await POST(APIS.Donation.UserDonationDetail, data);
      if (res?.success)
        return res;
      return rejectWithValue(res);

    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AllDonations = createAsyncThunk(
  "/website/user-donation-details-get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Donation.UserDonationDetail);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "userDonationDetails",
  initialState: {
    data: [],
    step1Data: {},
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetDonationDetails: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
    setDonationStep1Data: (state, action) => {
      state.step1Data = action.payload;
    },
    clearDonationData: (state) => {
      state.step1Data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AllDonations.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDonations.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(AllDonations.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(CreateUserDonationDetails.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateUserDonationDetails.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
      })
      .addCase(CreateUserDonationDetails.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetDonationDetails, setDonationStep1Data, clearDonationData } = Slice.actions;
export default Slice.reducer;
